export default {
  data() {
    return {
      urlSet: false,
    };
  },
  methods: {
    cleanUrl(urlString) {
      this.data.url = urlString
        .replace(/[&|\\/\\#,+()$~%.'":*?<>{}!@^[\];±§=_`]/g, '')
        .replace('--', '-')
        .toLowerCase()
        .split(' ')
        .join('-');

      // Remove all trailing '-' characters
      while (this.data.url.charAt(this.data.url.length - 1) === '-') {
        this.data.url = this.data.url.slice(0, -1);
      }

      // Remove all leading '-' characters
      while (this.data.url.charAt(0) === '-') {
        this.data.url = this.data.url.substr(1);
      }
    },

    suggestUrl(input) {
      if (!this.urlSet) {
        this.cleanUrl(input);
      }
    },

    setUrl() {
      this.urlSet = true;
    },
  },
};
